import type { TranslateFn } from './labels';

export type ModuleTranslateFn = (path: string, fallback: string) => string;

/** Translate a module string; `path` is relative to the module namespace root. */
export function moduleT(t: TranslateFn, path: string, fallback: string): string {
  if (!fallback) return t(path, { defaultValue: '' });
  return t(path, { defaultValue: fallback });
}

export function createModuleTranslator(t: TranslateFn): ModuleTranslateFn {
  return (path, fallback) => moduleT(t, path, fallback);
}

export function translateColumnHeader(
  mt: ModuleTranslateFn,
  columnKey: string,
  header: string | undefined,
): string {
  const fallback = header ?? columnKey;
  return mt(`columns.${columnKey}`, fallback);
}

export function translateFieldLabel(mt: ModuleTranslateFn, name: string, label: string | undefined): string {
  if (!label) return label ?? '';
  return mt(`fields.${name}.label`, label);
}

export function translateFieldPlaceholder(
  mt: ModuleTranslateFn,
  name: string,
  placeholder: string | undefined,
): string | undefined {
  if (!placeholder) return placeholder;
  return mt(`fields.${name}.placeholder`, placeholder);
}

export function translateFilterField(
  mt: ModuleTranslateFn,
  key: string,
  field: { label: string; placeholder?: string },
): { label: string; placeholder?: string } {
  return {
    label: mt(`filters.${key}.label`, field.label),
    placeholder: field.placeholder
      ? mt(`filters.${key}.placeholder`, field.placeholder)
      : undefined,
  };
}

export function translateSectionTitle(mt: ModuleTranslateFn, id: string, title: string): string {
  return mt(`sections.${id}`, title);
}

export function translateFilterGroupLabel(mt: ModuleTranslateFn, name: string, label: string): string {
  return mt(`filterGroups.${name}`, label);
}

export function translateToolbarTitle(mt: ModuleTranslateFn, key: string, title: string): string {
  const titled = mt(`toolbar.${key}.title`, '');
  if (titled) return titled;
  return mt(`toolbar.${key}`, title);
}

export function translateToolbarDropdownItem(
  mt: ModuleTranslateFn,
  actionKey: string,
  itemKey: string,
  label: string,
): string {
  return mt(`toolbar.${actionKey}.${itemKey}`, label);
}
